import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import accountPropTypes from '../../../states/accounts/propTypes';
import AccountPickerPage from '../AccountPicker/AccountPickerPage';
import PayeePickerPage from '../PayeePicker/PayeePickerPage';
import { ACCOUNT_PICKER_LAYOUT } from '../../constants';
import { payeePropTypes } from '../../../sharedComponents/FromToPayeeSelector/propTypes';
import { getCardViewClass } from '../../../states/accountPaging/utils/paging';
import { getSelectedPaymentId } from '../../../states/payeeSelector/selectors';
import { canAddMultiplePayees } from '../../../states/modes/selectors';

const mapState = (state) => ({
	selectedPayeeId: getSelectedPaymentId(state),
	canAddMultiplePayees: canAddMultiplePayees(state),
});

const PickerPage = ({
	accounts,
	payees,
	listViewSelected,
	onFavouriteIconClick,
	onAccountClick,
	layoutType,
	pageLoading = false,
	showPayees,
	handlePayeeSelect,
	getIsPayeeSelected,
	isManageYourPayee,
	handleViewPayee,
	handleDeletePayee,
	handleEditPayee,
	getIsAccountSelected,
	handleEditChaps,
	canAddMultiplePayees,
}) => {
	if (layoutType === ACCOUNT_PICKER_LAYOUT || !showPayees) {
		return (
			<AccountPickerPage
				accounts={accounts}
				listViewSelected={listViewSelected}
				onFavouriteIconClick={onFavouriteIconClick}
				onAccountClick={onAccountClick}
				cardClass={getCardViewClass(listViewSelected)}
				pageLoading={pageLoading}
				layoutType={layoutType}
				getIsAccountSelected={getIsAccountSelected}
				canAddMultiplePayees={canAddMultiplePayees}
			/>
		);
	}
	return (
		<PayeePickerPage
			payees={payees}
			listViewSelected={listViewSelected}
			onFavouriteIconClick={onFavouriteIconClick}
			handlePayeeSelect={handlePayeeSelect}
			pageLoading={pageLoading}
			cardClass={getCardViewClass(listViewSelected)}
			getIsPayeeSelected={getIsPayeeSelected}
			isManageYourPayee={isManageYourPayee}
			handleViewPayee={handleViewPayee}
			handleDeletePayee={handleDeletePayee}
			handleEditPayee={handleEditPayee}
			handleEditChaps={handleEditChaps}
			canAddMultiplePayees={canAddMultiplePayees}
		/>
	);
};

PickerPage.defaultProps = {
	getIsPayeeSelected: () => false,
};

PickerPage.propTypes = {
	pageLoading: PropTypes.bool.isRequired,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	listViewSelected: PropTypes.bool.isRequired,
	onAccountClick: PropTypes.func,
	onFavouriteIconClick: PropTypes.func.isRequired,
	layoutType: PropTypes.string.isRequired,
	payees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)),
	showPayees: PropTypes.bool.isRequired,
	handlePayeeSelect: PropTypes.func,
	getIsPayeeSelected: PropTypes.func,
	isManageYourPayee: PropTypes.bool,
	handleViewPayee: PropTypes.func,
	handleDeletePayee: PropTypes.func,
	handleEditPayee: PropTypes.func,
	getIsAccountSelected: PropTypes.func,
	selectedPayeeId: PropTypes.string.isRequired,
};

export { PickerPage };
export default connect(mapState)(PickerPage);
